/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { DEFAULT_FONT_FAMILY } from '@dynameat/constants';

export class Theme extends DaoModel {
  constructor(guid, primary_color, primary_font, primary_font_size_threshold, secondary_color,
    secondary_font, secondary_font_size_threshold, product_separation_threshold,
    description_separation_threshold, shopping_cart_icon_color,
    shopping_cart_shadow_icon_color, shopping_cart_size_threshold,
    shopping_cart_right_position_threshold, shopping_cart_bottom_position_threshold,
    shopping_cart_close_icon_color, shopping_cart_font_size_threshold, accent_color,
    background_color, background_image, header_background_color, border_style, border_width,
    border_color, subsection_border_style, subsection_border_width, subsection_border_color,
    special_color, special_space_border, has_logo, logo_position, text_outline_color,
    text_outline_width, background_color_free_text, pop_up_font, pop_up_font_size_threshold,
    pop_up_background_color, commercial_description_text_color,
    pop_up_text_color, commercial_description_text_indentation, footer_background_color,
    footer_text_color, footer_text_size, footer_branding_background_color,
    footer_branding_text_color, footer_branding_text_size, section_title_background_color,
    section_title_text_color, section_title_position, banner_recommendation_background_color,
    banner_recommendation_text_color, productSeparatorBorderStyle, productSeparatorBorderWidth,
    productSeparatorBorderColor, languageTextColor, bannerArrowColor,
    banner_font, banner_font_size_threshold, shopBtnColor, shopBtnTextColor) {
    super(guid);
    this.primary_color = primary_color || '#000000';
    this.primary_font = primary_font || DEFAULT_FONT_FAMILY;
    this.primary_font_size_threshold = primary_font_size_threshold || 0;
    this.secondary_color = secondary_color || '#000';
    this.secondary_font = secondary_font || DEFAULT_FONT_FAMILY;
    this.secondary_font_size_threshold = secondary_font_size_threshold || 0;
    this.product_separation_threshold = product_separation_threshold || 0;
    this.description_separation_threshold = description_separation_threshold || -5;
    this.shopping_cart_icon_color = shopping_cart_icon_color || '#000000';
    this.shopping_cart_shadow_icon_color = shopping_cart_shadow_icon_color || '#000000';
    this.shopping_cart_size_threshold = shopping_cart_size_threshold || 0;
    this.shopping_cart_right_position_threshold = shopping_cart_right_position_threshold || 0;
    this.shopping_cart_bottom_position_threshold = shopping_cart_bottom_position_threshold || 0;
    this.shopping_cart_close_icon_color = shopping_cart_close_icon_color || '#000000';
    this.shopping_cart_font_size_threshold = shopping_cart_font_size_threshold || 0;
    this.accent_color = accent_color || '#000000';
    this.background_color = background_color || '#FFFFFF';
    this.background_image = background_image || undefined;
    this.header_background_color = header_background_color || '#FFFFFF';
    this.border_style = border_style || 'auto';
    this.border_width = border_width || 0;
    this.border_color = border_color || '#000000';
    this.subsection_border_style = subsection_border_style || 'auto';
    this.subsection_border_width = subsection_border_width || 0;
    this.subsection_border_color = subsection_border_color || '#000000';
    this.special_color = special_color;
    this.special_space_border = special_space_border;
    this.has_logo = has_logo;
    this.logo_position = logo_position;
    this.text_outline_color = text_outline_color || primary_color;
    this.text_outline_width = text_outline_width || 0;
    this.background_color_free_text = background_color_free_text || '#FFFFFF';
    this.pop_up_font = pop_up_font || DEFAULT_FONT_FAMILY;
    this.pop_up_font_size_threshold = pop_up_font_size_threshold || 0;
    this.pop_up_background_color = pop_up_background_color || '#FFFFFF';
    this.commercial_description_text_color = commercial_description_text_color || '#FFFFFF';
    this.pop_up_text_color = pop_up_text_color || '#FFFFFF';
    this.commercial_description_text_indentation = commercial_description_text_indentation || 0;
    this.footer_background_color = footer_background_color || '#000000';
    this.footer_text_color = footer_text_color || '#FFFFFF';
    this.footer_text_size = footer_text_size || 0;
    this.footer_branding_background_color = footer_branding_background_color || '#000000';
    this.footer_branding_text_color = footer_branding_text_color || '#FFFFFF';
    this.footer_branding_text_size = footer_branding_text_size || 0;
    this.section_title_background_color = section_title_background_color || '#000000';
    this.section_title_text_color = section_title_text_color || '#FFFFFF';
    this.section_title_position = section_title_position;
    this.banner_recommendation_background_color = banner_recommendation_background_color || '#000000';
    this.banner_recommendation_text_color = banner_recommendation_text_color || '#FFFFFF';
    this.productSeparatorBorderStyle = productSeparatorBorderStyle || 'auto';
    this.productSeparatorBorderWidth = productSeparatorBorderWidth || 0;
    this.productSeparatorBorderColor = productSeparatorBorderColor || '#FFFFFF';
    this.languageTextColor = languageTextColor || '#FFFFFF';
    this.bannerArrowColor = bannerArrowColor || '#000000';
    this.banner_font = banner_font || DEFAULT_FONT_FAMILY;
    this.banner_font_size_threshold = banner_font_size_threshold || 0;
    this.shopBtnColor = shopBtnColor || '#000000';
    this.shopBtnTextColor = shopBtnTextColor || '#FFFFFF';
  }

  static toInstance(props = {}) {
    return new Theme(props.guid, props.primary_color, props.primary_font,
      props.primary_font_size_threshold, props.secondary_color, props.secondary_font,
      props.secondary_font_size_threshold, props.product_separation_threshold,
      props.description_separation_threshold, props.shopping_cart_icon_color,
      props.shopping_cart_shadow_icon_color, props.shopping_cart_size_threshold,
      props.shopping_cart_right_position_threshold, props.shopping_cart_bottom_position_threshold,
      props.shopping_cart_close_icon_color, props.shopping_cart_font_size_threshold,
      props.accent_color, props.background_color, props.background_image,
      props.header_background_color, props.border_style, props.border_width, props.border_color,
      props.subsection_border_style, props.subsection_border_width, props.subsection_border_color,
      props.special_color, props.special_space_border, props.has_logo, props.logo_position,
      props.text_outline_color, props.text_outline_width, props.background_color_free_text,
      props.pop_up_font, props.pop_up_font_size_threshold,
      props.pop_up_background_color, props.commercial_description_text_color,
      props.pop_up_text_color, props.commercial_description_text_indentation,
      props.footer_background_color, props.footer_text_color, props.footer_text_size,
      props.footer_branding_background_color, props.footer_branding_text_color,
      props.footer_branding_text_size, props.section_title_background_color,
      props.section_title_text_color, props.section_title_position,
      props.banner_recommendation_background_color, props.banner_recommendation_text_color,
      props.product_separator_border_style, props.product_separator_border_width, props.product_separator_border_color,
      props.language_text_color, props.banner_arrow_color, props.banner_font, props.banner_font_size_threshold,
      props.shop_btn_color, props.shop_btn_text_color);
  }

  serialize() {
    return {
      ...super.serialize(),
      primary_color: this.primary_color,
      primary_font: this.primary_font,
      primary_font_size_threshold: this.primary_font_size_threshold,
      secondary_color: this.secondary_color,
      secondary_font: this.secondary_font,
      secondary_font_size_threshold: this.secondary_font_size_threshold,
      product_separation_threshold: this.product_separation_threshold,
      description_separation_threshold: this.description_separation_threshold,
      shopping_cart_icon_color: this.shopping_cart_icon_color,
      shopping_cart_shadow_icon_color: this.shopping_cart_shadow_icon_color,
      shopping_cart_size_threshold: this.shopping_cart_size_threshold,
      shopping_cart_right_position_threshold: this.shopping_cart_right_position_threshold,
      shopping_cart_bottom_position_threshold: this.shopping_cart_bottom_position_threshold,
      shopping_cart_close_icon_color: this.shopping_cart_close_icon_color,
      shopping_cart_font_size_threshold: this.shopping_cart_font_size_threshold,
      accent_color: this.accent_color,
      background_color: this.background_color,
      background_image: this.background_image,
      header_background_color: this.header_background_color,
      border_style: this.border_style,
      border_width: this.border_width,
      border_color: this.border_color,
      subsection_border_style: this.subsection_border_style,
      subsection_border_width: this.subsection_border_width,
      subsection_border_color: this.subsection_border_color,
      special_color: this.special_color,
      special_space_border: this.special_space_border,
      has_logo: this.has_logo,
      logo_position: this.logo_position,
      text_outline_color: this.text_outline_color,
      text_outline_width: this.text_outline_width,
      background_color_free_text: this.background_color_free_text,
      pop_up_font: this.pop_up_font,
      pop_up_font_size_threshold: this.pop_up_font_size_threshold,
      pop_up_background_color: this.pop_up_background_color,
      commercial_description_text_color: this.commercial_description_text_color,
      pop_up_text_color: this.pop_up_text_color,
      commercial_description_text_indentation: this.commercial_description_text_indentation,
      footer_background_color: this.footer_background_color,
      footer_text_color: this.footer_text_color,
      footer_text_size: this.footer_text_size,
      footer_branding_background_color: this.footer_branding_background_color,
      footer_branding_text_color: this.footer_branding_text_color,
      footer_branding_text_size: this.footer_branding_text_size,
      section_title_background_color: this.section_title_background_color,
      section_title_text_color: this.section_title_text_color,
      section_title_position: this.section_title_position,
      banner_recommendation_background_color: this.banner_recommendation_background_color,
      banner_recommendation_text_color: this.banner_recommendation_text_color,
      product_separator_border_style: this.productSeparatorBorderStyle,
      product_separator_border_width: this.productSeparatorBorderWidth,
      product_separator_border_color: this.productSeparatorBorderColor,
      language_text_color: this.languageTextColor,
      banner_arrow_color: this.bannerArrowColor,
      banner_font: this.banner_font,
      banner_font_size_threshold: this.banner_font_size_threshold,
      shop_btn_color: this.shopBtnColor,
      shop_btn_text_color: this.shopBtnTextColor
    };
  }

  getFormData() {
    const formData = new FormData();
    formData.append('primary_color', this.primary_color);
    formData.append('primary_font', this.primary_font);
    formData.append('primary_font_size_threshold', this.primary_font_size_threshold);
    formData.append('secondary_color', this.secondary_color);
    formData.append('secondary_font', this.secondary_font);
    formData.append('secondary_font_size_threshold', this.secondary_font_size_threshold);
    formData.append('product_separation_threshold', this.product_separation_threshold);
    formData.append('description_separation_threshold', this.description_separation_threshold);
    formData.append('shopping_cart_icon_color', this.shopping_cart_icon_color);
    formData.append('shopping_cart_shadow_icon_color', this.shopping_cart_shadow_icon_color);
    formData.append('shopping_cart_size_threshold', this.shopping_cart_size_threshold);
    formData.append('shopping_cart_right_position_threshold', this.shopping_cart_right_position_threshold);
    formData.append('shopping_cart_bottom_position_threshold', this.shopping_cart_bottom_position_threshold);
    formData.append('shopping_cart_close_icon_color', this.shopping_cart_close_icon_color);
    formData.append('shopping_cart_font_size_threshold', this.shopping_cart_font_size_threshold);
    formData.append('accent_color', this.accent_color);
    formData.append('background_color', this.background_color);
    formData.append('header_background_color', this.header_background_color);
    formData.append('border_style', this.border_style);
    formData.append('border_width', this.border_width);
    formData.append('border_color', this.border_color);
    formData.append('subsection_border_style', this.subsection_border_style);
    formData.append('subsection_border_width', this.subsection_border_width);
    formData.append('subsection_border_color', this.subsection_border_color);
    formData.append('special_color', this.special_color);
    formData.append('special_space_border', this.special_space_border);
    formData.append('has_logo', this.has_logo);
    formData.append('logo_position', this.logo_position);
    formData.append('text_outline_color', this.text_outline_color);
    formData.append('text_outline_width', this.text_outline_width);
    formData.append('background_color_free_text', this.background_color_free_text);
    formData.append('pop_up_font', this.pop_up_font);
    formData.append('pop_up_font_size_threshold', this.pop_up_font_size_threshold);
    formData.append('pop_up_background_color', this.pop_up_background_color);
    formData.append('commercial_description_text_color', this.commercial_description_text_color);
    formData.append('pop_up_text_color', this.pop_up_text_color);
    formData.append('commercial_description_text_indentation', this.commercial_description_text_indentation);
    formData.append('footer_background_color', this.footer_background_color);
    formData.append('footer_text_color', this.footer_text_color);
    formData.append('footer_text_size', this.footer_text_size);
    formData.append('footer_branding_background_color', this.footer_branding_background_color);
    formData.append('footer_branding_text_color', this.footer_branding_text_color);
    formData.append('footer_branding_text_size', this.footer_branding_text_size);
    formData.append('section_title_background_color', this.section_title_background_color);
    formData.append('section_title_text_color', this.section_title_text_color);
    formData.append('section_title_position', this.section_title_position);
    formData.append('banner_recommendation_background_color', this.banner_recommendation_background_color);
    formData.append('banner_recommendation_text_color', this.banner_recommendation_text_color);
    formData.append('product_separator_border_style', this.productSeparatorBorderStyle);
    formData.append('product_separator_border_width', this.productSeparatorBorderWidth);
    formData.append('product_separator_border_color', this.productSeparatorBorderColor);
    formData.append('language_text_color', this.languageTextColor);
    formData.append('banner_arrow_color', this.bannerArrowColor);
    formData.append('banner_font', this.banner_font);
    formData.append('banner_font_size_threshold', this.banner_font_size_threshold);
    formData.append('shop_btn_color', this.shopBtnColor);
    formData.append('shop_btn_text_color', this.shopBtnTextColor);
    if (this.background_image instanceof File) {
      if (this.background_image.size !== 0) {
        formData.append('background_image', this.background_image, this.background_image.name);
      }
    } else if (!this.background_image) {
      formData.append('background_image', '');
    }
    return formData;
  }
}
